<!-- <app-header></app-header> -->
    <div class="site-content-wrap">

        <!-- In-App support Section -->
        <section class="section-wrap pt-4 pb-5" >
            <div class="container">
                <div class="site-content-block ">
                    <div class="block-content-box px-4 px-sm-0">
                        <div class="block-heading pe-lg-5">
                            <h2 class="title m-0 pb-3 font-w-600 pe-lg-5"> {{staticData.title}}</h2>
                        </div>                  
                    <div class="block-content pb-4">
                        <p  [innerHtml]="staticData.description"> </p>
                    </div>
                </div>
            </div>
            </div>
        </section>

    </div>
    <!-- <app-footer></app-footer> -->

